import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useModalState } from "@src/appV2/redesign/system/ui-components";

import { SentHomeRequestOptionsBottomSheet } from "../Dialogs/SentHomeRequestOptionsBottomSheet";

interface SentHomeRequestOptionsButtonProps {
  shiftId: string;
}

export function SentHomeRequestOptionsButton(props: SentHomeRequestOptionsButtonProps) {
  const { shiftId } = props;

  const sentHomeRequestOptionsModalState = useModalState();

  return (
    <>
      <IconButton
        variant="outlined"
        iconType="ellipsis"
        aria-label="Sent home request options"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.SENT_HOME_REQUEST_OPTIONS_OPENED, { shiftId });
          sentHomeRequestOptionsModalState.openModal();
        }}
      />
      <SentHomeRequestOptionsBottomSheet
        modalState={sentHomeRequestOptionsModalState}
        shiftId={shiftId}
      />
    </>
  );
}
